import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Footer-branding text normaliser.
 *
 * Tenant admins set ``branding.powered_by_text`` in the Admin →
 * Branding form. The customer-facing footer renders that as
 *   ``Powered by {powered_by_text}``
 * so the expected input is just the brand name (e.g. ``"Bizil"``).
 *
 * Historically several tenants typed the full phrase
 * (``"Powered by Bizil"``) into that field, producing the
 * "Powered by Powered by Bizil" duplication shown in the
 * user-reported iOS screenshot (iter91, Feb 2026).
 *
 * Defensive trim — strip a leading "Powered by " (case-insensitive,
 * single occurrence) before the template adds its own. Empty / null
 * input falls back to ``"Bizil"`` (the platform default).
 */
export function poweredByBrand(value) {
  const raw = (value || "").toString().trim();
  if (!raw) return "Bizil";
  return raw.replace(/^powered\s+by\s+/i, "").trim() || "Bizil";
}
